import { InfoCircle } from 'react-bootstrap-icons';

export const HelpTextHover = () => {
    return (
        <InfoCircle className="tooltipIcon" size={16} color="#625E5B" />
    );
};